export const randomBool = (): boolean => Math.random() < 0.5;
